<div class="bg-light-low dark:bg-dark-low dark:[&>*]:text-gray-200">
  <router-outlet></router-outlet>
</div>
<fc-toast></fc-toast>
<fc-confirm></fc-confirm>
